import {useNavigate} from "react-router-dom"

export default function NavBar(){
  const navigate= useNavigate()
  const toHome= ()=>{
    navigate('/')
  }
return(
    <div className='justify-between flex flex-row'>
        <nav className='justify-between flex bg-gray-800 w-screen h-16'>
          <ul className='pl-5 pt-2 relative text-white'>
            <li><img className='absolute pt-1' src='https://cdn.icon-icons.com/icons2/2699/PNG/512/netflix_logo_icon_170919.png' style={{width: "40px"}} alt=""/><h1 className='pl-10 pt-1' style={{fontSize:"20pt"}}>Movie</h1></li>
          </ul>
          <ul>
            <li className='pt-3 pr-20 text-white'>
            <button style={{fontSize:"20pt", fontFamily:'Press Start 2P'}} onClick={toHome}>Home</button>
            {/* <button className='pl-5' style={{fontSize:"20pt"}}>Movie</button> */}
            </li>
          </ul>
          <ul className='pt-4 pr-5 text-white'>

          </ul>
        </nav>
        </div>
)
}